<template>
	<div class="work-wrapper">
		<div class="tabs-wrapper">
			<a-tabs
				@tabClick="handleTabClick"
				@edit="handleTabEdit"
				:activeKey="activeKey"
				type="editable-card"
				defaultActiveKey="WorkHomeIndex"
				:hideAdd="true"
				size="small"
			>
				<a-tab-pane key="WorkHomeIndex" :closable="false">
          <div slot="tab" class="ant-tabs-tab-icon">
            <img :src="require('@/assets/home/icon-applys-blue.svg')" />
            工作台
          </div>
				</a-tab-pane>
				<template v-if="tabList">
					<a-tab-pane v-for="tab in tabList" :key="tab.code" :closable="true">
						<div slot="tab" class="ant-tabs-tab-icon">
							<img :src="filePreview(tab.icon)" />{{tab.name}}
						</div>
					</a-tab-pane>
				</template>
			</a-tabs>
		</div>
		<iframe-layout
			v-show="$route.name === iframe.code"
			v-for="iframe in iframeList"
			:key="iframe.code"
			:url="iframe.url"
      :code="iframe.code"
		>
		</iframe-layout>
		<keep-alive>
			<router-view v-if="!$route.meta.url && isWork"/>
		</keep-alive>
	</div>
</template>

<script>
import { mapState } from "vuex";
import IframeLayout from "@/layouts/IframeLayout.vue";

export default {
	name: "WorkView",
	components: {IframeLayout},
	computed: {
		...mapState({
			tabs: state => state.tabs.tabs,
			iframeList: state => state.tabs.iframeList,
		}),
		tabList() {
			return this.tabs.filter(tab => tab.code !== 'WorkHomeIndex')
		},
		activeKey() {
			if (this.$store.getters.currentTab) {
				return this.$store.getters.currentTab.code
			} else {
				return 'WorkHomeIndex'
			}
		},
		isWork() {
			return this.$route.name === 'WorkHomeIndex' || this.$route.meta.type === 'app'
		},
	},
	data() {
		return {
		}
	},
	methods: {
		handleTabEdit(key) {
			this.$store.dispatch('DeleteTab', key).then(() => {
				this.$router.push({name: 'WorkHomeIndex'})
			})
		},
		handleTabClick(key) {
			console.log('handleTabClick', key)
			this.$store.dispatch('ActiveTab', key).then(() => {
				this.$router.push({name: key})
			})
		}
	}
}
</script>

<style scoped lang="less">
.work-wrapper {
	display: flex;
	flex: 1;
	flex-direction: column;
	align-items: flex-start;
  background: rgb(242,245,248);
  width: 0;
	.tabs-wrapper {
		display: flex;
		width: 100%;
		height: 45px;
		background-color: #d8dfe6;
    padding: 10px 15px 0 15px;
    /deep/ .ant-tabs-bar {
      margin: 0;
      .ant-tabs-tab {
        width: 188px;
        height: 35px;
        line-height: 35px;
        border: 0;
        border-radius: 8px 8px 0 0;
        margin-right: 0px;
        padding: 0 20px 0 20px;
        background: none;
        position: relative;
        font-size: 13px;
        &:after {
          content: '';
          position: absolute;
          width: 1px;
          height: 20px;
          z-index: 9;
          right: 0px;
          top: 8px;
          background: #bfbfbf;
        }
        &.ant-tabs-tab-active {
          background: url("~@/assets/home/tab-bg.png");
          &:after {
            right: auto;
            left: -1px;
            background: #d8dfe6;
          }
        }
        .ant-tabs-tab-icon {
          color: #05051a;
          display: inline-block;
          img {
            height: 16px;
            margin-right: 5px;
            vertical-align: -3px;
            border-radius: 3px;
          }
        }
        .ant-tabs-close-x {
          float: right;
          margin-top: 12px;
          color: #787889;
        }
        &:first-child {
          .ant-tabs-tab-icon img {
            border-radius: 0;
          }
        }
      }
      .ant-tabs-tab-arrow-show {
        margin-top: -3px;
      }
    }
	}
}
</style>
